import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

export interface ILogMessage {
    object?: any;
    message: string;
}

@Injectable()
export class LoggerService {

    private logInfoMessage = new Subject<ILogMessage>();
    public logInfoMessage$ = this.logInfoMessage.asObservable();

    private logSuccessMessage = new Subject<ILogMessage>();
    public logSuccessMessage$ = this.logSuccessMessage.asObservable();

    private logWarningMessage = new Subject<ILogMessage>();
    public logWarningMessage$ = this.logWarningMessage.asObservable();

    private logErrorMessage = new Subject<ILogMessage>();
    public logErrorMessage$ = this.logErrorMessage.asObservable();

    private logToConsole(message: ILogMessage, consoleIt: boolean) {
        if (message !== undefined && message.message !== undefined) {
            if (consoleIt) {
                //console.log(message.message, message.object || '');
            }
        }
    }

    public info(message: ILogMessage, toastIt?: boolean, consoleIt?: boolean) {
        if (message !== undefined && message.message !== undefined) {
            this.logToConsole(message, consoleIt);
            if (toastIt) {
                this.logInfoMessage.next(message);
            }
        }
    }

    public success(message: ILogMessage, toastIt?: boolean, consoleIt?: boolean) {
        if (message !== undefined && message.message !== undefined) {
            this.logToConsole(message, consoleIt);
            if (toastIt) {
                this.logSuccessMessage.next(message);
            }
        }
    }

    public warning(message: ILogMessage, toastIt?: boolean, consoleIt?: boolean) {
        if (message !== undefined && message.message !== undefined) {
            this.logToConsole(message, consoleIt);
            if (toastIt) {
                this.logWarningMessage.next(message);
            }
        }
    }

    public error(message: ILogMessage, toastIt?: boolean, consoleIt?: boolean) {
        if (message !== undefined && message.message !== undefined) {
            this.logToConsole(message, consoleIt);
            if (toastIt) {
                this.logErrorMessage.next(message);
            }
        }
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/core/logger/global-logger.service.ts